module.exports = __webpack_public_path__ + "img/tapeInMethod3.3342f21d.jpg";